<template>
	<div class="rge-root" :style="{backgroundImage:'url('+loginBgImg+')'}">
		<div class="header-container">
			<div class="back-button" @click="gotoLogin()">&lt;</div>
			<div class="reg_header" @click="gotoLogin()">注册嘉友</div>
		</div>
		<div class="content">
			<div class="rge-input">
				<!-- <div @click="checkMobileNoUnique">test</div> -->
				<!-- <span class="rge-input-title" @click="gotoRegResult">培训员编号</span> -->
				<span class="rge-input-title">培训员编号</span>
				<div class="rge-input-right" style="width:100%">
				<el-input placeholder="输入培训员编号" style="width:57%" class="rge-input-content" type="number" v-model="loginPass.intro_no"
					@input="validPwdNull" @blur="checkIntroNo" name="intro_no"></el-input>
					<span class="cstar">*</span>
					<img class="icon_question" mode="widthFix" @click="clickQuestion" src="../assets/icon-question.png"></img>
					<span class="intro_span">{{ introName }}</span>
				</div>
			</div>
			<div class="rge-input">
				<span class="rge-input-title">申请人姓名</span>
				<el-input placeholder="输入申请人姓名" class="rge-input-content2" type="text" v-model="loginPass.mb_name"
					@input="validPwdNull" name="mb_name"></el-input>
				<span class="cstar">*</span>
			</div>
			<div class="rge-input"">
				<span class="rge-input-title">身份证号</span>
				<el-input placeholder="输入身份证号" class="rge-input-content2" type="text" v-model="loginPass.id_no"
					@input="validPwdNull" name="id_no"></el-input>
				<span class="cstar">*</span>
			</div>
			<div class="rge-input"">
				<span class="rge-input-title">手机号</span>
				<el-input placeholder="输入手机号" class="rge-input-content2" type="number" v-model="loginPass.mobile_no"
					minlength="13" maxlength="13" @input="resetParams" name="mobile_no"></el-input>
				<span class="cstar">*</span>
			</div>
			<div class="rge-input" >
				<span class="rge-input-title">验证码</span>
					<el-input placeholder="输入验证码" type="number" v-model="loginPass.smsCode" maxlength="6"
						minlength="6" @input="validPwdNull" name="smsCode"></el-input>
          			<div class="smscode" @click="checkThreeParams" :disabled="isCounting">{{ sendCodeBtnTxt }}</div>
				<span class="cstar">*</span>
			</div>
			<div class="link-forget">验证码有效期为15分钟，请勿重复发送验证码</div>
      		
			<el-button class="confirm_btn" @click="register" :disabled="isComplete == false">确定</el-button>
			
			<div class="reg-cb">
				<div>
					<label class="reg-cb-box" @click="handlePrivacy">
						<el-checkbox value="a" :checked="isAgree" v-model="isAgree" />
						<span class="text-grey1">阅读并同意</span>
					</label>
					<span class="textButton" @click="handlePrivacy">《嘉康利隐私政策》</span>
				</div>
				<div>
					<label class="reg-cb-box" @click="handlePrivacy2">
						<el-checkbox value="b" :checked="isAgree2" v-model="isAgree2" />
						<span class="text-grey1">阅读并同意入会须知</span>
					</label>
					<span class="textButton" @click="handlePrivacy2">《嘉友须知》</span>
				</div>
				<div>
					<label class="reg-cb-box" @click="handlePrivacy3">
						<el-checkbox value="c" :checked="isAgree3" v-model="isAgree3" />
						<span class="text-grey1">阅读并同意</span>
					</label>
					<span class="textButton" @click="handlePrivacy3">《e签宝条款》</span>
				</div>

			</div>
		</div>
		
        <RegPrivacyPopup :isAgree="showAgree" @close="hideRegPopup(1)" />
        <MbstPrivacyPopup :isAgree="showAgree2" @close="hideRegPopup(2)" />
        <ESignPrivacyPopup :isAgree="showAgree3" @close="hideRegPopup(3)" />

	</div>
</template>
<script>
import { requestApi, checkMobileNo, checkIDNumber } from '@/utils/request';
import { MessageBox } from 'element-ui';
import RegPrivacyPopup from '../components/RegPrivacyPopup.vue';
import MbstPrivacyPopup from '../components/MbstPrivacyPopup.vue';
import ESignPrivacyPopup from '../components/ESignPrivacyPopup.vue';

let remotePicUrl = 'https://prodcdn.shaklee.com.cn';
export default {
	computed: {
		isComplete() {
			return this.loginPass.smsCode != "" && this.loginPass.mobile_no != "" && this.loginPass.intro_no!="" && this.loginPass.mb_name!="" && this.loginPass.id_no!="";
		}
	},
	components: {
		RegPrivacyPopup,
		MbstPrivacyPopup,
		ESignPrivacyPopup,
	},
	data() {
		return {
			pageTitle:"嘉康利官方商城",
			showQuestion: false,
			sendCodeBtnTxt: "发送验证码",
			questionContent: '请填写您的“培训员编号”，如没有可以填写编号10000010',
			isMobileNoUnique: false,
			logoImg: '/static/images/login/registerLogo.png',
			iconQuestion: '/static/images/login/icon-question.png',
			loginBgImg: remotePicUrl + '/shaklee/upload/register-bg01.png',
			isAgree: false,
			isAgree2: false,
			isAgree3: false,
			showAgree: false,
			showAgree2: false,
			showAgree3: false,
			pwdNull: true,
			secondNull: true,
			// isComplete: false,
			regMbNo: '', //注册的会员号
			regPwd: '', //注册的pwd
			logoUrl: '',
			codeFlag: true,
			backgroundImage: '',
			topImage: '',
			backgroundMiddleImage: '',
			iconWeixin: '',
			loginPass: {
				// intro_no: '10660767',
				intro_no: '',
				mb_name: '',
				//id_no: '41020219821202153X',
				id_no: '',
				mobile_no: '',
				wx_union_id: '',
				smsCode: ''
			},
			showPageLoading: true,
			btnLoading: false,
			introName: '',
			isUnique: true,
			isPass: false,
			isCounting:false,
			countdown: 60,
			errorMsg: "",
        	loadingInstance: null,
		};
	},
	created() {
    	document.title = this.pageTitle;
	},
	methods: {
		gotoLogin() {
			this.$router.push({ path: '/' })
		},
		gotoRegResult() {
			// this.regMbNo = '10088877';
			// this.regPwd = '123456';
			console.log('gotoRegResult', this.regMbNo);
			this.$router.push({ path: '/reg_result', query: { regMbNo: this.regMbNo, regPwd: this.regPwd } })
		},
		knowConfirm() {
			this.showQuestion = false
			// if(!this.loginPass.intro_no){
			// 	this.loginPass.intro_no = '10000010'
			// 	this.checkIntroNo()
			// }
		},
		clickQuestion() {
			MessageBox.alert(this.questionContent, '', {
				customClass: 'reg-message-box'
			}).then(() => {

			});
		},
		showLoadingBox() {
			this.loadingInstance = this.$loading({
				lock: true,
				body: true,
				text: '网络请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.6)',
				target: document.body,
				customClass: ' sk-loading-class'
			});
		},
		closeLoadingBox() {
          	this.loadingInstance.close();
		},
		hideRegPopup(num) {
			// console.log(num);
			switch (num) {
				case 1 :
					this.isAgree = true;
					this.showAgree = false;
					break;
				case 2 :
					this.isAgree2 = true;
					this.showAgree2 = false;
					break;
				case 3 :
					this.isAgree3 = true;
					this.showAgree3 = false;
					break;
				default:
					break;
			}
		},
		// 获取推荐人信息
		checkIntroNo() {
			if (!this.loginPass.intro_no) {
				this.introName = ''
				return false
			}
			// this.showLoadingBox();
			const loginInfo = {
				"intro_no": this.loginPass.intro_no
			}
			const funUrl = "/member/check_intro_no";
			requestApi(funUrl, loginInfo, 1)
			.then((respData) => {
				// this.closeLoadingBox() ;
				console.log('checkIntroNo', respData);
				if (respData && respData.code == 0) {
					this.introName = respData.data.intro_name;
				} else {
					this.introName = '';
					// this.errorMsg = respData.message;
					// this.$message({
					// 	type: 'info',
					// 	message: respData.message,
					// 	duration: 2000
					// })
					MessageBox.alert(respData.message, '提示', {
						customClass: 'reg-message-box'
					}).then(() => {
					});
					return false;
				}
			})
			.catch(error => {
				// this.closeLoadingBox() ;
				return;
			});
		},
		// 校验手机号码唯一.逻辑已经包含在了3要素里面，不单独用了
		async checkMobileNoUnique() {
			return true;
			// if (this.chkedMobileNoUnique) {
			// 	return false;
			// }
			if (!this.loginPass.mobile_no) {
				// this.$modal.msg("请输入手机号码")
				this.$message({
					type: 'info',
					message: '请输入手机号码',
					duration: 2000
				})
				return false;
			} else if (!checkMobileNo(this.loginPass.mobile_no.replace(/\s*/g, ""))) {
				// this.$modal.msg("请输入正确的手机号码")
				this.$message({
					type: 'info',
					message: '请输入正确的手机号码',
					duration: 2000
				})
				return false;
			}
			this.isMobileNoUnique = false;
			this.showLoadingBox() ;
			const loginInfo = {
				"mobile_no": this.loginPass.mobile_no.replace(/\s*/g, "")
			}
			const funUrl = "/member/check_mobile_no_unique";
			try {
				const respData = await requestApi(funUrl, loginInfo, 1);
				this.closeLoadingBox();
				if (respData && respData.code === 0 && respData.data.is_unique) {
					console.log(respData.data);
					this.isMobileNoUnique = true;
					// this.chkedMobileNoUnique = true;
					console.log('finished true'); 
					return true;
				} else {
					// this.chkedMobileNoUnique = true;
					this.isMobileNoUnique = false;
					console.log('finished false'); 
					return false;
				}
			} catch (error) {
				this.closeLoadingBox();
				return false;
			} finally {
				this.closeLoadingBox();
				// console.log('finished???'); 
				return this.isMobileNoUnique;
			}  
		},
		
		// 进行三方验证
		async checkThreeParams() {
			if (this.isCounting) {
				console.log("sendCode is working");
				return;
			}
        	// this.isCounting = true;
			if (this.loginPass.intro_no === "") {
				this.$message({
					message: '请输入培训员编码',
					type: 'info',
					duration: 2000,
				});
				return false;
			}
			if (this.introName == "") {
				MessageBox.alert('培训员编号错误', '提示', {
					customClass: 'reg-message-box'
				}).then(() => {
				});
				return false;
			}

			if (this.loginPass.mb_name === "") {
				this.$message({
					type: 'info',
					message: '请输入申请人姓名',
					duration: 2000
				})
				return false;
			}
			if (this.loginPass.mb_name.length < 2) {
				this.$message({
					type: 'info',
					message: '申请人姓名需为2个字及以上',
					duration: 2000
				})
				return false;
			}
			// console.log(this.loginPass.id_no);
			if (this.loginPass.id_no === "") {
				// this.$modal.msg("请输入身份证号")
				this.$message({
					type: 'info',
					message: '请输入身份证号',
					duration: 2000
				})
				return false;
			}
			if (!checkIDNumber(this.loginPass.id_no.replace(/\s*/g, ""))) {
				this.$message({
					type: 'info',
					message: '请输入正确的身份证号',
					duration: 2000
				})
				return false;
			}
			if (this.loginPass.mobile_no === "") {
				// this.$modal.msg("请输入手机号码")
				this.$message({
					type: 'info',
					message: '请输入手机号码',
					duration: 2000
				})
				return false;
			}
			if (!checkMobileNo(this.loginPass.mobile_no.replace(/\s*/g, ""))) {
				// this.$modal.msg("请输入正确的手机号码")
				this.$message({
					type: 'info',
					message: '请输入正确的手机号码',
					duration: 2000
				})
				return false;
			}

			// this.isPass = false
			const loginInfo = {
				"mobile_no": this.loginPass.mobile_no.replace(/\s*/g, ""),
				"id_no": this.loginPass.id_no,
				"mb_name": this.loginPass.mb_name
			}
			this.showLoadingBox();
        	this.isCounting = true;
			const funUrl = "/member/check_id";
			requestApi(funUrl, loginInfo, 1)
			.then((respData) => {
				this.closeLoadingBox();
				console.log('check_id', respData);
				if (respData && respData.code == 0) {
					if (respData.message == "" || respData.message == "验证码发送成功") {
          				// this.sendCodeBtnTxt = "发送成功";
						this.$message({
							type: 'info',
							message: '验证码已发送',
							duration: 2000
						});
						const intervalR = setInterval(() => {
							if (this.countdown > 0) {
								this.sendCodeBtnTxt = "重新发送(" + `${this.countdown})`;
								this.countdown--;
							} else {
								clearInterval(intervalR);
								this.isCounting = false;
								this.sendCodeBtnTxt = '发送验证码';
								this.countdown = 60;
							}
						}, 1000);
					} else {
						this.errorMsg = "输入数据不正确，请检查.";
        				this.isCounting = false;
					}
				} else {
					this.errorMsg = respData.message;
        			this.isCounting = false;
				}
			})
			.catch(error => {
				this.closeLoadingBox();
        		this.isCounting = false;
				return;
			});
		},
		// 确定注册
		register() {
			if (this.loginPass.intro_no === "") {
				// this.$modal.msg("请输入培训员编码")
				this.$message({
					type: 'info',
					message: '请输入培训员编号',
					duration: 2000
				})
				return false
			}
			if (this.loginPass.mb_name === "") {
				this.$message({
					type: 'info',
					message: '请输入申请人姓名',
					duration: 2000
				})
				return false
			}
			if (this.loginPass.mb_name.length < 2) {
				this.$message({
					type: 'info',
					message: '申请人姓名需为2个字及以上',
					duration: 2000
				})
				return false
			}
			if (this.loginPass.id_no === "") {
				// this.$modal.msg("请输入身份证号")
				this.$message({
					type: 'info',
					message: '请输入身份证号',
					duration: 2000
				})
				return false
			}
			if (!checkIDNumber(this.loginPass.id_no.replace(/\s*/g, ""))) {
				this.$message({
					type: 'info',
					message: '请输入正确的身份证号',
					duration: 2000
				})
				return false
			}
			if (this.loginPass.mobile_no === "") {
				// this.$modal.msg("请输入手机号码")
				this.$message({
					type: 'info',
					message: '请输入手机号码',
					duration: 2000
				})
				return false
			}
			if (!checkMobileNo(this.loginPass.mobile_no.replace(/\s*/g, ""))) {
				// this.$modal.msg("请输入正确的手机号码")
				this.$message({
					type: 'info',
					message: '请输入正确的手机号码',
					duration: 2000
				})
				return false
			}

			if (this.loginPass.smsCode === "") {
				// this.$modal.msg("请输入验证码")
				this.$message({
					type: 'info',
					message: '请输入验证码',
					duration: 2000
				})
				return false
			}
			if (this.loginPass.smsCode.length !== 6) {
				// this.$modal.msg("验证码必须为6位数字")
				this.$message({
					type: 'info',
					message: '验证码必须为6位数字',
					duration: 2000
				})
				return false
			}
			if (!this.isAgree || !this.isAgree2 || !this.isAgree3) {
				this.$message({
					type: 'info',
					message: '请阅读并同意全部协议',
					duration: 2000
				})
				return false
			}
			this.showLoadingBox();
			const loginInfo = {
				'mb_name': this.loginPass.mb_name,
				'id_no': this.loginPass.id_no,
				'mobile_no': this.loginPass.mobile_no.replace(/\s*/g, ""),
				'intro_no': this.loginPass.intro_no,
				'auth_type': 3,
				'auth_code': this.loginPass.smsCode,
          		'platform': 1,  //H5
			}
			const funUrl = "/member/register";
			requestApi(funUrl, loginInfo, 1)
			.then((respData) => {
				this.closeLoadingBox() ;
				console.log('register', respData);
				if (respData && respData.code == 0) {
					console.log(respData);
					this.regMbNo = respData.data.mb_no; //'10088877';
					this.regPwd = respData.data.mb_pwd; //'123456';
					this.$message({
						type: 'info',
						message: '注册成功!',
						duration: 1000
					});
					this.gotoRegResult();
				} else {
					// this.errorMsg = respData.message;
					console.log(respData);
					this.$message({
						type: 'info',
						message: respData.message,
						duration: 3000
					})
					return false;
				}
			})
			.catch(error => {
				this.closeLoadingBox() ;
				return;
			});
		},
		// 同意隐私协议
		setAgree(e) {
			console.log(e.detail.val);
			this.selectVal = e.detail.value
			// this.$emit('setAgree', this.isAgree)
			// this.isAgree = e.detail.value.length === 3 ? true : false
			if (e.detail.value.length === 3) {
				this.isAgree = true
				this.isAgree2 = true
				this.isAgree3 = true
			}
		},

		// 验证码登录按钮是否禁用
		resetParams() {
			this.isMobileNoUnique = false;
		},
		// 密码登录按钮是否禁用
		validPwdNull() {
			this.pwdNull = true
			if (this.loginPass.intro_no && this.loginPass.mb_name && this.loginPass.id_no &&
				this.loginPass.mobile_no.replace(/\s*/g, "") && this.loginPass.smsCode) {
				this.pwdNull = false
			}
		},
		// 隐私协议
		handlePrivacy() {
        	this.isAgree = true;
        	this.showAgree = true;
		},
		// 隐私协议
		handlePrivacy2() {
        	this.isAgree2 = true;
        	this.showAgree2 = true;
		},
		// 隐私协议
		handlePrivacy3() {
        	this.isAgree3 = true;
        	this.showAgree3 = true;
		},

		singleCheckChange(val) {
			console.log('singleCheckChange');
			// if (this.selectVal.indexOf(val) !== -1) {
			// 	val === 'a' ? this.handlePrivacy() : val === 'b' ? this.handlePrivacy2() : this.handlePrivacy3()
			// }
			if (val === 'a') {
				this.isAgree = !this.isAgree
				console.log(this.isAgree, 'isAgree')
			} else if (val === 'b') {
				this.isAgree2 = !this.isAgree2
				console.log(this.isAgree2, 'isAgree2')
			} else if (val === 'c') {
				this.isAgree3 = !this.isAgree3
				console.log(this.isAgree3, 'isAgree3')
			}
		}
	},

	watch: {
		errorMsg(newVal, oldVal) {
			if (newVal && newVal !== oldVal) {
				MessageBox.alert(newVal, '提示', {
					customClass: 'reg-message-box'
				}).then(() => {
					this.errorMsg = "";
				});
			}
		}
	}
};
</script>

<style lang="scss">
.header-container {
	display: flex;
	align-items: center;
	background: #f1f3f4;
	position: fixed;
	z-index: 999;
	width: 100%;
	padding-top: 1em;
	padding-bottom: 5px;
	box-sizing: border-box; /* 确保内边距不会影响宽度 */
  }
  
  .back-button {
	font-size: 20px;
	font-weight: 600;
	color: #014134;
	margin-left: 5%; /* 右边距，使标题与按钮之间有一定的间距 */
  }

.reg_header {
	background: #f1f3f4;
	text-align: left;
	line-height: 14px;
	font-weight: 600;
	color: #014134;
	font-size: 20px;
	margin-left: auto; /* 使标题向右推 */
	margin-right: auto; /* 使标题向左推 */
	padding-right: 15%;
	padding-top: 0.5em;
}

.confirm_btn {
	margin-top: 1.2rem;
	margin-left: 1.5rem;
	margin-bottom: 1rem;
	width: 90%;
	height: 45px;
	border-radius: 25px;
	border: none;
	background-color: #173f35;
	color: #fff;
	align-self: center;
}
.confirm_btn:focus {
	background-color: #173f35;
	color: #fff;
}

.confirm_btn:disabled {
	background-color: #909399;
	color: white;
	cursor: not-allowed;
	opacity: 0.7;
}
.confirm_btn.is-disabled:hover {
	background-color: #909399;
	color: white;
	cursor: not-allowed;
	opacity: 0.7;
}


.rge-root {
	width: 100%;
	height: 100vh;
	overflow: auto;
	background: #fff;
	font-family: pingfang;
	//background-size: cover;
	background-size: 100% 100%;
	//background-position: 20% 90%;
	//background-position: calc(20% + 2px) calc(100%);
	background-attachment: fixed;
	/* 背景图片固定在视口中 */
	min-width: 350px;
	min-height: 100vh;
	position: relative;

	.content {
		position: fixed;
		width: 90%;
		margin-top: 4.5rem;
		padding-left: 2%;
	}

	.rge-input {
		display: flex;
		flex-direction: row;
		align-items: left;
		padding-bottom: 5px;

		.rge-input-title {
			width: 33%;
			padding-left: 6%;
			padding-top: 20px;
			padding-right: 5px;
			font-size: 14px;
			color: #000000;
			text-align: center;
		}

		.icon_question {
			padding-top: 0.7rem;
			padding-left: 0.3rem;
			width: 15px;
			height: 15px;
		}

		.intro_span {
			margin-left: 6px;
			flex-wrap: wrap;
			top: 50%;
			transform: translateY(30%);
			font-size: 14px;
		}

		.smscode {
			position: absolute;
			right: 0.7rem;
			/* 调整右边距 */
			top: 50%;
			/* 垂直居中 */
			transform: translateY(73%);
			/* 垂直居中 */
			color: #409eff;
			/* 可以根据需要调整颜色 */
			font-size: 12px;
			border-radius: 4px;
			padding-right: 12px;
			font-weight: 600;
		}

		.el-input__inner {
			width: 95%;
			border: none;
			height: 2.2rem;
			line-height: 3.0rem;
			border-radius: 2.5rem;
			margin-top: 10px;
			margin-left: 10px;
			color: black;
			background: white;
		}

		.el-input__inner::placeholder {
			font-size: 12px;
		}

		.rge-input-right {
			font-weight: 400;
			display: flex;
			align-items: center;
			color: #000000;
			margin-right: 38rpx;
		}


		.cstar {
			margin-left: 5px;
			padding-top: 18px;
			color: red;
		}

		rge-input-content2 {
			font-size: 12px;
		}
	}

	.link-forget {
		text-align: right;
		color: #979797;
		margin-left: 230rpx;
		font-size: 10px;
		padding-right: 6%;
	}

	.reg-cb {
		display: flex;
		margin-top: 24rpx;
		flex-direction: column;
		margin-left: 20%;
		text-align: left;
		font-size: 12px;
		width: 80%;

		.reg-cb-box {
			font-size: 12px;

			.text-grey1 {
				line-height: 200%;
				color: #A1A1A1;
			}


		}

		.textButton {
			font-size: 12px;
			margin-left: 14rpx;
			color: #2688E1;
		}
	}

}

	/* 调整大小 */
	.reg-message-box.el-message-box {
		width: 80%;
		text-align: center;
	}
	.el-button.el-button--primary {
		color: #fff;
		background-color: #173f35;
		border-color: #173f35;
	}

	/* 调整位置 */
	.reg-message-box.el-message-box__wrapper {
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%);
	}
	.el-message-box__btns{
		text-align: center;
	}

	.el-message {
		background-color: #003300;
		/* 背景颜色 */
		border-radius: 8px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
		left: 50% !important;
		top: 30% !important;
		max-width: 100%;
		min-width: unset !important; 
		padding-left: 7px !important;
		padding-right: 7px !important;
	}

	/* 自定义消息文本样式 */
	.el-message__content {
		font-size: 12px;
		/* 字体大小 */
		/* 文字颜色 */
		color: white !important;
	}
	.el-message__icon {
		display: none !important;
	}

	.el-checkbox__inner {
		border-radius: 0px !important;
		transform: scale(0.8);
	}
	
	.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #308A78;
	border-color: #308A78;
	}
</style>


// WEBPACK FOOTER //
// src/page/register.vue